import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../../queries';
import { useAPIErrorHandler } from '../../useAPIErrorHandler';

export type UseQuoteDetailsProps = { id?: string; product?: string };

export function useQuoteDetails(props: UseQuoteDetailsProps) {
  const handleAPIError = useAPIErrorHandler();

  return useQuery({
    ...queries.quotes.detail(props.id as string, props.product as string),
    keepPreviousData: true,
    onError: handleAPIError("Unable to fetch quote's details"),
    select: (data) => data.data,
    enabled: Boolean(props.id) && Boolean(props.product),
  });
}
